import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as moment from 'moment';
import { RangoFechas } from 'src/app/Models/rangofechas/rango-fechas';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-print-ventas-por-cliente',
  templateUrl: './print-ventas-por-cliente.component.html',
  styleUrls: ['./print-ventas-por-cliente.component.css'],
  providers: [DatePipe]
})
export class PrintVentasPorClienteComponent implements OnInit {

  constructor(
      private reportViewer: ReportViewerService,
      private data: DataService,
      private datePipe: DatePipe,
      private cdr: ChangeDetectorRef
    ) { }
  mes: string = '1';
  public detfactus: any[] = [];
  public sumacantidad:number = 0;
  public sumapreuni:number = 0;
  public sumatotal:number = 0;
  public pagventas:any = 0;
  public rangofechas: RangoFechas= new RangoFechas();
  public today = new Date();
  public fecinicio:any;
  public fecfin:any;
  public sucursal:number;
  @ViewChild('pagina', null) public pagina: ElementRef;
  async ngOnInit() {
  }

  printer() {
    const doc = new jsPDF();
    console.log(this.pagina.nativeElement);
    doc.text("Hello world!", 10, 10);
    doc.save("a4.pdf");
  }


  onMonthSelect() {
    if (this.mes) {
      // Obtener el año actual
      const year = moment().year();

      // Obtener la fecha de inicio y fin del mes seleccionado usando Moment.js
      this.fecinicio = moment(`${year}-${this.mes}-01`).startOf('month').format('YYYY-MM-DD');
      this.fecfin = moment(`${year}-${this.mes}-01`).endOf('month').format('YYYY-MM-DD');
    }
  }

  GetData(){
    this.data.GetFromValue('ventasclientes_total',this.mes,this.sucursal.toString()).subscribe(r => {
      console.log(r);
      if (r.length<1) {
        console.error("Error");
      }else{
        this.detfactus = r;
        this.GetTotalVentas()
        this.cdr.detectChanges();
        setTimeout(() => {
          // Generar el PDF
          const blob = this.printerVentas();
          // Mostrar en el modal reutilizable
          if (blob) {
            const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
            this.reportViewer.mostrarPDF(
              blob,
              'Reporte de Ventas por Cliente',
              `reporte_ventas_por_clientes_${fecha}.pdf`
            );
          }
        })
      }
    },e => { console.log(e) })
  }

  GetTotalVentas(){
    this.detfactus.forEach(detalle => {

      this.sumatotal+= +detalle.total_cantidad
    });
    
  }

  public isbutton: Boolean = true;
  click:boolean = false;

  async print() {
    const backButton = document.getElementById('backButton');
    if (backButton) {
      backButton.style.display = 'none';
    }

    // Remover el iframe anterior si existe
    const existingIframe = document.querySelector('iframe');
    if (existingIframe) {
      document.body.removeChild(existingIframe);
    }

    const element = this.pagina.nativeElement;
    const canvas = await html2canvas(element, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL('image/png');

    // Definir las dimensiones del formato A4 en mm
    const pageWidth = 210; // Ancho de A4 en mm
    const pageHeight = 297; // Alto de A4 en mm
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * pageWidth) / canvas.width; // Proporción de altura basado en el ancho de A4

    const doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'a4'
    });

    let position = 0;
    let heightLeft = imgHeight;

    // Añadir la primera página
    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Añadir páginas adicionales si el contenido es más grande que una página
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    doc.autoPrint({ variant: 'non-conform' });

    const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      if (iframe.contentWindow) {
        iframe.contentWindow.print();
      }
    };

    if (backButton) {
      backButton.style.display = 'block';
    }
  }
  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }
  printerVentas():Blob | null {
    const doc = new jsPDF();
    const titulo = { text: 'VENTAS A CLIENTES', x: 80, y: 20 };


    // Función para agregar encabezado en cada página
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);  // Obtener el ancho del texto
      const lineY = titulo.y + 1;  // Posición Y de la línea (1 unidad por debajo del texto)

      doc.setLineWidth(0.5);  // Establecer el grosor de la línea
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(11);
      doc.text(`Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`, 10, 28);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 140, 28);
      //doc.addImage(this.empresa.logo, 'PNG', 10, 8, 20, 9);  // Añade tu imagen
      doc.setFontSize(12);
    };

    // Columnas de la tabla
    
    const tableColumn = ['N°', 'Nombre Cliente','Producto', 'Direccion', 'Celular','Cantidad'];
    const tableRows: any[] = [];

    // Obtener filas de una tabla HTML (ejemplo)
    const rows = document.querySelectorAll('#ventasporcliente tbody tr');
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const data: any[] = [];
      cols.forEach(col => data.push(col.innerText));
      tableRows.push(data);
    });

    // Usar autoTable para generar la tabla
    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 10, vertical: 30 },
      theme: 'grid',
      columnStyles: {
        7: { halign: 'right' },
        8: { halign: 'right' },
        9: { halign: 'right' }
        // Alinear la columna "Cantidad" (índice 3) a la derecha
      },
      styles: {
        fontSize: 8,  // Controla el tamaño de fuente para todo el contenido de la tabla
        cellPadding: 1,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        // Encabezado en cada página

        const pageNumber = data.pageNumber;  // Obtener el número de página
        //const pageCount = doc.getNumberOfPages();

        console.log(data.totalPages);

        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 170, 15);  // Añade tu imagen
      },
      didDrawHeader: (data: any) => {
        doc.setFontSize(10);
        doc.text('N°', data.settings.margin.left, data.cursor.y);
        doc.text('Nombre Cliente', data.settings.margin.left, data.cursor.y);
        doc.text('Producto', data.settings.margin.left, data.cursor.y);
        doc.text('Direccion', data.settings.margin.left, data.cursor.y);
        doc.text('Celular', data.settings.margin.left, data.cursor.y);
        doc.text('Cantidad', data.settings.margin.left, data.cursor.y);
      }
    });

    // Guardar el archivo PDF
    return doc.output('blob');
    //doc.save('informe.pdf');

  }
  
  mouseenter() {
    if(!this.click){
      this.isbutton = true;
    } else{
      this.isbutton = false;
    }
  }

  back(){
    //this.router.navigateByUrl("/");
    window.history.back();
  }


}
